export default {
  state: {
    driverNotes: {
      show: false
    }
  },
  mutations: {
    showDriverNotes (state) { state.driverNotes.show = true },
    hideDriverNotes (state) { state.driverNotes.show = false }
  }
}



// WEBPACK FOOTER //
// ./src/store/rsvp-edit/driver-notes.js